var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"language-switcher",class:{
		'loading': _vm.loading,
		'mobile': _vm.mobileMode,
		'desktop': !_vm.mobileMode,
	}},_vm._l((_vm.items),function(item,index){return _c('router-link',{key:item.language,staticClass:"language-link",attrs:{"to":item.route},nativeOn:{"click":[function($event){return _vm.$emit('change', item.language)},function($event){$event.preventDefault();$event.stopPropagation();return _vm.changeLanguage(item.language)}]}},[_vm._v(_vm._s(item.caption))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }